import React from "react";

export type Column<T> = {
  header: string;
  accessor: keyof T | string;
  cell?: (value: any, row: T) => React.ReactNode;
  // Optional: Add className to customize column styles
  className?: string;
};

type Props<T> = {
  columns: Column<T>[];
  data: T[];
};

export default function DataTable<T>({ columns, data }: Props<T>) {
  return (
    <table className="w-full text-sm border-collapse text-slate-800 dark:text-slate-100 bg-white dark:bg-slate-800">
      <thead>
        <tr className="bg-slate-100 dark:bg-slate-700/60 text-slate-700 dark:text-slate-200">
          {columns.map((col, idx) => (
            <th
              key={idx}
              className={`px-3 py-2 border border-slate-200 dark:border-slate-700 text-center font-semibold ${col.className ?? ""}`}
            >
              {col.header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((row, rowIndex) => (
          <tr
            key={rowIndex}
            className="bg-white dark:bg-slate-800 hover:bg-slate-50 dark:hover:bg-slate-700/60 transition-colors"
          >
            {columns.map((col, colIndex) => {
              const value =
                typeof col.accessor === "string"
                  ? (row as any)[col.accessor]
                  : row[col.accessor];
              return (
                <td
                  key={colIndex}
                  className={`px-3 py-2 border border-slate-200 dark:border-slate-700 text-center ${col.className ?? ""}`}
                >
                  {col.cell ? col.cell(value, row) : value}
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
